import { useState } from 'react';

// The usePagination hook manages pagination state for a component.
// It keeps track of the current page and provides
// functions to navigate to the next or previous page, while ensuring that the page number stays within valid limits (for example, not less than 0 and not exceeding the total number of pages).

export function usePagination(totalPages: number) {
  const [currentPage, setCurrentPage] = useState(0);

  const hasNextPage = currentPage + 1 < totalPages;
  const hasPreviousPage = currentPage > 0;

  const fetchNextPage = () => {
    if (hasNextPage) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const fetchPreviousPage = () => {
    if (hasPreviousPage) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  return {
    currentPage,
    hasNextPage,
    hasPreviousPage,
    fetchNextPage,
    fetchPreviousPage
  };
}
